import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from '../../forum/app';
import FormModal from '../../common/components/FormModal';
import Button from '../../common/components/Button';
import Stream from '../../common/utils/Stream';
import ItemList from '../../common/utils/ItemList';
import Form from '../../common/components/Form';

/**
 * The `ChangeEmailModal` component shows a modal dialog which allows the user
 * to change their email address.
 */
export default class ChangeEmailModal extends FormModal {
  constructor() {
    super(...arguments);
    /**
     * The value of the email input.
     */
    _defineProperty(this, "email", void 0);
    /**
     * The value of the password input.
     */
    _defineProperty(this, "password", void 0);
    /**
     * Whether or not the email has been changed successfully.
     */
    _defineProperty(this, "success", false);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.email = Stream(app.session.user.email() || '');
    this.password = Stream('');
  }
  className() {
    return 'ChangeEmailModal Modal--small';
  }
  title() {
    return app.translator.trans('core.forum.change_email.title');
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m(Form, {
      className: "Form--centered"
    }, this.fields().toArray()));
  }
  fields() {
    const items = new ItemList();
    if (this.success) {
      items.add('help', m("p", {
        className: "helpText"
      }, app.translator.trans('core.forum.change_email.confirmation_message', {
        email: m("strong", null, this.email())
      })));
      items.add('dismiss', m("div", {
        className: "Form-group"
      }, m(Button, {
        className: "Button Button--primary Button--block",
        onclick: this.hide.bind(this)
      }, app.translator.trans('core.forum.change_email.dismiss_button'))));
    } else {
      items.add('email', m("div", {
        className: "Form-group"
      }, m("input", {
        type: "email",
        name: "email",
        className: "FormControl",
        placeholder: app.session.user.email(),
        bidi: this.email,
        disabled: this.loading
      })));
      items.add('password', m("div", {
        className: "Form-group"
      }, m("input", {
        type: "password",
        name: "password",
        className: "FormControl",
        autocomplete: "current-password",
        placeholder: app.translator.trans('core.forum.change_email.confirm_password_placeholder'),
        bidi: this.password,
        disabled: this.loading
      })));
      items.add('submit', m("div", {
        className: "Form-group Form-controls"
      }, m(Button, {
        className: "Button Button--primary Button--block",
        type: "submit",
        loading: this.loading
      }, app.translator.trans('core.forum.change_email.submit_button'))));
    }
    return items;
  }
  onsubmit(e) {
    e.preventDefault();

    // If the user hasn't actually entered a different email address, we don't
    // need to do anything. Woot!
    if (this.email() === app.session.user.email()) {
      this.hide();
      return;
    }
    this.loading = true;
    this.alertAttrs = null;
    app.session.user.save(this.requestAttributes(), {
      errorHandler: this.onerror.bind(this),
      meta: {
        password: this.password()
      }
    }).then(() => {
      this.success = true;
    }).catch(() => {}).then(this.loaded.bind(this));
  }
  requestAttributes() {
    return {
      email: this.email()
    };
  }
  onerror(error) {
    if (error.status === 401 && error.alert) {
      error.alert.content = app.translator.trans('core.forum.change_email.incorrect_password_message');
    }
    super.onerror(error);
  }
}
flarum.reg.add('core', 'forum/components/ChangeEmailModal', ChangeEmailModal);